import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { PlainTextHeader } from 'Deer/components/HeaderComponents/PlainTextHeader';
import { getApplicableL2MyTeamModules } from 'Deer/components/navigation/secondary/MyTeam/MyTeamModules';
import { L3_CONTENT } from 'Deer/constants/L3RenderMap';
import { useDeerTeamType } from 'Deer/hooks/useDeerTeamType';
import { useRouteToMyTeamLevels } from 'Deer/hooks/useRouteToL3';
import { MyCompetenciesIntent } from 'Deer/intent/Competencies/MyCompetenciesIntent';
import { CompetenciesIntentDropdown } from 'Deer/intent/Competencies/components/CompetenciesIntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useDispatch } from 'react-redux';
import { setSelectedView } from 'reducers/viewsSlice';
import { MyCompetencies as MyCompetenciesComponent } from 'screens/ContinuousFeedback/MyCompetencies/MyCompetencies';
import { checkIntentLandingPagesFeatureEnabled, checkNewCompetencyPanelEnabled } from 'utils/helpers/featureFlags';

import { PageTabbedNavigationV1 } from 'uiToolkitV1/PageTabbedNavigationV1';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cohort: any;
}

const DirectReportsDevelopManage = ({ cohort }: Props) => {
  const dispatch = useDispatch();
  const { l3Options: tabs } = useRouteToMyTeamLevels();
  const teamType = useDeerTeamType();
  const { moduleName } = useOrganisationSettings();
  const applicableL2DirectReportsModules = getApplicableL2MyTeamModules('directReports', moduleName);
  const applicableL2AllReportsModules = getApplicableL2MyTeamModules('allReports', moduleName);

  const filteredTabs = tabs.filter(
    (tab) => checkNewCompetencyPanelEnabled() || tab.label !== L3_CONTENT.team.directReports.develop.manage.label
  );

  useEffect(() => {
    dispatch(setSelectedView({ ...cohort, teamId: cohort.id }));
    return () => {
      dispatch(setSelectedView({}));
    };
  }, [cohort, dispatch]);

  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <CompetenciesIntentDropdown
            breadcrumbs={{
              items: [
                {
                  label: teamType === 'allReports' ? 'Skip Team' : 'Direct Team',
                  to:
                    teamType === 'allReports'
                      ? applicableL2AllReportsModules[0]?.value
                      : applicableL2DirectReportsModules[0]?.value,
                },
              ],
              page: {
                label: 'Feedback',
                to: '',
              },
            }}
          />
        }
      >
        <MyCompetenciesIntent />
      </Layout>
    );
  }

  return (
    <>
      <PlainTextHeader>My direct team&apos;s competencies</PlainTextHeader>
      <PageTabbedNavigationV1 tabs={filteredTabs} />
      <Box my={1} />
      <MyCompetenciesComponent />
    </>
  );
};

export default DirectReportsDevelopManage;
